module.exports = __webpack_public_path__ + "img/ferro-cromo-mobile.cce36ac5.png";